'use client';
import { useEffect, useState } from "react";
import DOMPurify from "dompurify";
import SwiperCore from "swiper";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

SwiperCore.use([Navigation, Pagination]); // Register Swiper modules

const decodeHtmlEntities = (text: string) => {
  const textarea = document.createElement("textarea");
  textarea.innerHTML = text;
  return textarea.value;
};

const SanitizedContent = ({
  content,
  is_copyable,
}: {
  content: string;
  is_copyable: boolean;
}) => {
  const [cleanContent, setCleanContent] = useState<string>("");

  useEffect(() => {
    const decodedContent = decodeHtmlEntities(content);
    const replacedContent = decodedContent
  .replace(/<p><gallery><\/p>/g, "<gallery>")
  .replace(/<p><\/gallery><\/p>/g, "</gallery>");
    console.log(replacedContent)
    const sanitizedContent = DOMPurify.sanitize(replacedContent, {
      ADD_TAGS: ["iframe", "div", "script", "noscript", "gallery"],
      ADD_ATTR: [
        "class",
        "src",
        "width",
        "height",
        "style",
        "scrolling",
        "frameborder",
        "allow",
        "allowfullscreen",
        "data-src",
      ],
    });

    const parser = new DOMParser();
    const doc = parser.parseFromString(sanitizedContent, "text/html");

    const iframes = doc.querySelectorAll("iframe");
    iframes.forEach((iframe) => {
      iframe.classList.add("mx-auto", "mt-3");
    });

    // Convert //gallery markers into Swiper carousels
    const galleries = doc.querySelectorAll("gallery");

    galleries.forEach((gallery, index) => {
      // If gallery is wrapped in a <p>, unwrap it
      const parentTag = gallery.parentElement;
      if (parentTag && parentTag.tagName.toLowerCase() === 'p') {
        parentTag.replaceWith(gallery); // Unwrap gallery from <p>
      }

      const imageTags = gallery.querySelectorAll("img");
      console.log(gallery);
      const slides = Array.from(imageTags).map((imgTag) => {
        const src = imgTag.getAttribute("src");
        return `<div class="swiper-slide"><img src="${src}" alt="Gallery Image" class="w-full h-auto" /></div>`;
      });
      const swiperHTML = `
        <div id="swiper-container-${index}" class="swiper-container overflow-hidden relative select-none">
          <div class="swiper-wrapper">
            ${slides.join("")}
          </div>
          <div class="swiper-button-prev">
          </div>
          <div class="swiper-button-next">
          </div>
          <div class="swiper-pagination"></div>
        </div>
      `;
      gallery.outerHTML = swiperHTML;
    });
    
    setCleanContent(doc.body.innerHTML);
  }, [content]);

  useEffect(() => {
    const swiperContainers = document.querySelectorAll(".swiper-container");
    swiperContainers.forEach((container, index) => {
      new SwiperCore(container as HTMLElement, {
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: {
          nextEl: `#swiper-container-${index} .swiper-button-next`,
          prevEl: `#swiper-container-${index} .swiper-button-prev`,
        },
        pagination: {
          el: `#swiper-container-${index} .swiper-pagination`,
          clickable: true,
        },
      });
    });
  }, [cleanContent]);

  return (
    <div
      className={`news-article-content ${is_copyable ? "" : "no-copy"}`}
      dangerouslySetInnerHTML={{ __html: cleanContent }}
    />
  );
};

export default SanitizedContent;
